import { useRoutes } from 'react-router-dom';
import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MainLayout from 'layout/MainLayout';
import BlankLayout from 'layout/BlankLayout';

// routes
import MainRoutes from './MainRoutes';
import OtherRoutes from './OtherRoutes';
import ApiRoutes from './ApiRoutes';

// canvas route
const Canvas = Loadable(lazy(() => import('views/Canvas')));

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  return useRoutes([
    MainRoutes, 
    OtherRoutes, 
    ApiRoutes,
    {
      path: '/canvas',
      element: <BlankLayout />,
      children: [
        {
          path: '',
          element: <Canvas />
        }
      ]
    }
  ]);
}
